/* Keep the automatic shopping-agent launcher clear of the first purchase view. */
(() => {
  const update = () => {
    const button = document.querySelector('il-product-page [data-main-buy]');
    document.body.classList.toggle('il-product-past-purchase', !button || button.getBoundingClientRect().bottom < 0);
  };
  let frame = null;
  const schedule = () => {
    if (frame !== null) return;
    frame = requestAnimationFrame(() => { frame = null; update(); });
  };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  // Once a visitor opens or focuses the agent, keep it available during navigation.
  const interacted = event => {
    if (event.composedPath().some(node => node.id === 'ads-agent-host')) document.body.classList.add('il-product-agent-opened');
  };
  document.addEventListener('click', interacted);
  document.addEventListener('focusin', interacted);
  update();
})();
